import { render, staticRenderFns } from "./EditRegionModal.vue?vue&type=template&id=5d9893b0&"
import script from "./EditRegionModal.vue?vue&type=script&lang=js&"
export * from "./EditRegionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports